<template>
  <div class="conversion-form">
    <div class="conversion-form-item">
      <span class="item-index">{{ index }}</span>
      <component :is="componentName" :strategyList="strategyList"/>
    </div>
    <div class="opt">
      <i
        class="el-icon-document-copy"
        @click="global.handleCopyClick(formData)"
      ></i>
      <i class="el-icon-delete" @click="global.handleDelClick(formData.id)"></i>
    </div>
  </div>
</template>

<script>
import ConversionForm from "./conversionForm.vue"
import CommonForm from "./commonForm.vue"
import deepConversionForm from "./deepConversionForm.vue"
import NonConversionForm from './nonConversionForm.vue'
import { validNum } from '@/utils/validate'
export default {
	components: {},
	props: ["formData", 'index'],
	provide() {
		return {
			formData: this.formData,
      moneyRules: this.moneyRules,
		}
	},
	inject: ["global"],
	data() {
    const validCost = (rule, value, callback) => {
			if(!validNum(value)) {
				callback(new Error('请输入正确的价格'));
			}else {
        if(+value > 0 && +value<1000000000 ) {
          callback();
         
        }else{
          callback(new Error('请输入1000000000以下的价格'));
        }
				
			}
		}
		return {
      moneyRules: [
				{ required: true, message: '请输入' },
				{ validator: validCost, trigger: ['change', 'blur'] }
			],
    }
	},
	computed: {
		strategyList() {
			const way = this.formData.way;
			if(!way ) {
				return
			}
			const keyPriceType = _.keyBy(this.global.config.price_type, 'value')
// 			"枚举值
// price_type为PRICING_OCPC时必填"
			// ocpc_strategy
			const strategyList = _.filter(this.global.config.ocpc_strategy, { pid: keyPriceType[way].param_id  });
      if(!strategyList.length) {
        return;
      }
			return strategyList;
		},
		componentName() {
			const { way , deep } = this.formData
			if (!way ) {
				return CommonForm
			}
			if( !deep && way === 'PRICING_OCPC' ) {
				return ConversionForm
			};
			if(way !== 'PRICING_OCPC') {
				return NonConversionForm
			}
			return deepConversionForm
		},
	},
	watch: {},
	methods: {
		
	},
}
</script>
<style>
.is-error + .form-item__tip {
  display: none;
}
</style>
<style lang="scss" scoped>
.conversion-form {
  display: flex;
  min-height: 170px;
  margin-bottom: 16px;
  &-item {
    flex: 1;
    width: 0;
    // height: 100%;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 12px 0;
    position: relative;
    .item-index {
      position: absolute;
      top: 10px;
      right: 10px;
      border: 1px solid #ccc;
      min-width: 30px;
      height: 30px;
      text-align: center;
      line-height: 30px;
      border-radius: 15px;
      font-size: 12px;
      color: #409eff;
    }
  }
  .opt {
    width: 60px;
    text-align: right;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 16px;
    i {
      display: block;
      margin-left: auto;
      font-size: 18px;
      margin-top: 20px;
      color: red;
      cursor: pointer;
      &:first-child {
        margin-top: 0;
        color: #409eff;
      }
    }
  }
  &::v-deep .el-input-group__append {
    background: #409eff;
    color: #fff;
  }
}
</style>